import { useSelector } from "react-redux";

const useLocale = () => useSelector(state => state.locale || 'es-ES')

export default useLocale